const a = {
  unsavedChanges: {
    title: "Unsaved Changes",
    body: "Are you sure you want to continue?",
    secondaryButton: "No",
    primaryButton: "Yes",
    uses: "When a user exits a dirty form.",
    category: "Dialogs"
  }
}, s = {
  requiredField: {
    errorMessage: "Required",
    uses: "Message returned when a required field is empty.",
    category: "Form Validation"
  },
  maxCharacter: {
    500: "Must be 500 characters or less.",
    255: "Must be 255 characters or less.",
    150: "Must be 150 characters or less.",
    100: "Must be 100 characters or less.",
    50: "Must be 50 characters or less.",
    lambda: (e) => `Must be ${e} character${e !== 1 ? "s" : ""} or less.`,
    uses: "When a field has a max character count.",
    category: "Max Characters"
  },
  minCharacter: {
    lambda: (e) => `Must be at least ${e} character${e !== 1 ? "s" : ""}.`,
    uses: "When a field has a min character count.",
    category: "Min Characters"
  },
  exactCharacter: {
    lambda: (e) => `Must be exactly ${e} character${e !== 1 ? "s" : ""}.`,
    uses: "When a field has an exact character count.",
    category: "Exact Characters"
  },
  number: {
    positiveNumbersOnly: "Must be a positive number.",
    uses: "When validation is needed on numbers.",
    category: "Number Validation"
  },
  email: {
    errorMessage: "Must be a valid email.",
    uses: "When validation is needed on email addresses.",
    category: "Email Validation"
  }
};
export {
  a as dialogStrings,
  s as validationStrings
};
//# sourceMappingURL=index.js.map
